import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import Search from './Search.gql';

export const useSearch = (options) => {
  return useQuery(Search, {
    ...options,
    url: ApiUrl.graphQl(),
    requestPolicy: 'no-cache',
  });
};
